import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "okHandFilled"
const OkHandFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M8.451 3.576C9.184 2.844 10.371 2.844 11.103 3.576L19.693 12.166 19.823 12.308Q19.88 12.378 19.928 12.454L19.97 12.52Q19.996 12.563 20.022 12.612 20.036 12.636 20.047 12.662 20.077 12.721 20.103 12.782L20.116 12.819Q20.14 12.88 20.159 12.943L20.177 13.006Q20.192 13.061 20.203 13.116L20.213 13.173Q20.225 13.236 20.231 13.298L20.235 13.337Q20.239 13.407 20.24 13.477L20.242 13.5H20.25V22.5H9.773V22.428Q9.526 22.393 9.281 22.338C7.677 21.97 6.27 21.01 5.342 19.65 4.77 18.81 4.406 17.853 4.271 16.86 4.13 15.841 5.11 15.128 6.129 15.282S7.797 16.467 8.306 17.362Q8.362 17.457 8.426 17.55C8.821 18.133 9.423 18.544 10.11 18.701 10.797 18.857 11.518 18.748 12.128 18.395 12.737 18.043 13.19 17.472 13.397 16.8 13.604 16.126 13.548 15.399 13.242 14.765 12.935 14.13 12.399 13.637 11.743 13.38 11.087 13.126 10.357 13.128 9.703 13.387Q9.597 13.43 9.497 13.478C8.574 13.933 7.458 14.421 6.528 13.978 5.6 13.535 5.19 12.396 5.877 11.63 6.545 10.884 7.382 10.295 8.328 9.92 9.23 9.564 10.192 9.416 11.143 9.476Q11.811 9.59 12.443 9.848C13.433 10.255 14.296 10.916 14.948 11.762 15.137 12.008 15.489 12.053 15.735 11.864 15.982 11.674 16.028 11.32 15.838 11.075 15.066 10.072 14.043 9.29 12.872 8.808 12.114 8.496 11.312 8.318 10.5 8.275L8.451 6.227C7.72 5.495 7.72 4.307 8.451 3.576M18.375 2.25C19.411 2.25 20.25 3.09 20.25 4.125V11.132L16.5 7.382V4.125C16.5 3.089 17.34 2.25 18.375 2.25" />
        </svg>
      }
    </span>
  )
}
export default OkHandFilledIcon
